import { create } from "zustand"
import api from "../services/api"

export const useFilaStore = create((set, get) => ({
  filas: [],
  loading: false,
  error: null,
  cacheInvalid: true,
  fetching: false,

  fetchFilas: async () => {
    if (!get().cacheInvalid && get().filas.length > 0) return
    set({ loading: true, error: null, fetching: true, filas: [] })
    const { data } = await api.get("/queue")
    set({ filas: data, cacheInvalid: false })
  },

  invalidateCache: () => {
    set({ cacheInvalid: true })
  },

  getFilas: async () => {
    const { cacheInvalid, fetchFilas } = get()
    if (cacheInvalid) {
      await fetchFilas()
    }
    return get().filas
  },
}))
